/** Fixed expense categories. Account code is per category; tax type is not. */
export const RECEIPT_CATEGORIES = [
  'fuel',
  'van',
  'travel',
  'subsistence',
  'client_entertaining',
  'software',
  'materials',
  'tools',
  'hire',
  'office_costs',
  'phone_internet',
  'professional',
  'insurance',
  'other',
] as const;

export type ReceiptCategory = (typeof RECEIPT_CATEGORIES)[number];

export const RECEIPT_CATEGORY_LABEL: Record<ReceiptCategory, string> = {
  fuel: 'Fuel',
  van: 'Van',
  travel: 'Travel',
  subsistence: 'Subsistence',
  client_entertaining: 'Client entertaining',
  software: 'Software',
  materials: 'Materials',
  tools: 'Tools',
  hire: 'Hire',
  office_costs: 'Office costs',
  phone_internet: 'Phone & internet',
  professional: 'Professional',
  insurance: 'Insurance',
  other: 'Other',
};

/**
 * UK input tax on entertaining clients, customers or suppliers is blocked
 * (VAT (Input Tax) Order 1992 art. 5). Do not add staff/director entertaining —
 * that would imply a reclaim that HMRC does not allow for a sole director.
 */
export const RECEIPT_CATEGORY_VAT_RECOVERY_BLOCKED: Record<
  ReceiptCategory,
  boolean
> = {
  fuel: false,
  van: false,
  travel: false,
  subsistence: false,
  client_entertaining: true,
  software: false,
  materials: false,
  tools: false,
  hire: false,
  office_costs: false,
  phone_internet: false,
  professional: false,
  insurance: false,
  other: false,
};

export const RECEIPT_CATEGORY_ACCOUNTANT_CONFIRM: Record<
  ReceiptCategory,
  boolean
> = {
  fuel: false,
  van: false,
  travel: false,
  subsistence: false,
  client_entertaining: true,
  software: false,
  materials: false,
  tools: false,
  hire: false,
  office_costs: false,
  phone_internet: false,
  professional: false,
  insurance: false,
  other: false,
};

export function isReceiptCategory(v: string): v is ReceiptCategory {
  return (RECEIPT_CATEGORIES as readonly string[]).includes(v);
}

/** Lowercase, collapse whitespace, strip most punctuation for map lookup. */
export function normalizeSupplierKey(name: string): string {
  return name
    .normalize('NFKC')
    .toLowerCase()
    .replace(/['’`]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}
